module.exports = __webpack_public_path__ + "static/media/post-04.d914aa57.jpg";